import client from "shared/setupClient";
import { loader } from "graphql.macro";
const addChecklistItemMutation = loader("graphql/mutations/checklist/addChecklistItem.graphql");

export default function addChecklistItemAction(checklistId, item) {
    const { label, type } = item;
    const variables = { checklistId, label, type };
    return client.mutate({
        mutation: addChecklistItemMutation, variables
    });
}
